import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

export default class ObjectGenerator{
	constructor(currentEnv, roomName, roomConfig, whereToAddObjects, data) {
		this.gltfLoader = new GLTFLoader();
		this.composedObjectName = ["Classe", "Ronde", "Pole"];
	}

	AddElement(name, parent, posParameter, visibility, simsData, forceAdd) {
		if (this.composedObjectName.includes(name) || this.composedObjectName.includes(name.replace("bibliotheque/", ""))) {
			this["Generate" + name.replace("bibliotheque/", "")](parent, posParameter, visibility, simsData, forceAdd);
		}
		else {
			this.CreateObject(name, parent, posParameter, visibility, simsData);
		}
	}

	CreateObject(name, parent, posParameter, visibility, simsData) {
		this.gltfLoader.load("./models/" + name + ".glb", 
		(gltf) => {
			var objectToAdd = gltf.scene;
			objectToAdd.name = name.replace("bibliotheque/", "");
			gltf.scene.traverse( child => {
				if ( child.isMesh ) {
					child.castShadow = true;
					child.receiveShadow = false;
				}
			});

			if (simsData) {
				objectToAdd.simsData = structuredClone(simsData);
			}

			parent.add(objectToAdd);
			if (visibility != null) {
				objectToAdd.visible = visibility;
			}


			if (posParameter) {
				if (posParameter.refObject) {
					objectToAdd.position.x = posParameter.refObject.position.x;
					objectToAdd.position.y = posParameter.refObject.position.y;
					//objectToAdd.position.y = 0;
					objectToAdd.position.z = posParameter.refObject.position.z;

					objectToAdd.rotation.x = posParameter.refObject.rotation.x;
					objectToAdd.rotation.y = posParameter.refObject.rotation.y;
					objectToAdd.rotation.z = posParameter.refObject.rotation.z;
				}
				else {
					if (posParameter.posX)
						objectToAdd.position.x = posParameter.posX;
					if (posParameter.posY)
						objectToAdd.position.y = posParameter.posY;
						//objectToAdd.position.y = 0;
					if (posParameter.posZ)
						objectToAdd.position.z = posParameter.posZ;

					if (posParameter.rotX)
						objectToAdd.rotation.x = posParameter.rotX;
					if (posParameter.rotY)
						objectToAdd.rotation.y = posParameter.rotY;
					if (posParameter.rotZ)
						objectToAdd.rotation.z = posParameter.rotZ;
				}

				if (posParameter.functionToAdd) {
					posParameter.functionToAdd();
				}
			}
			
		}, undefined, function ( error ) {
			console.error( error );
		} );
	}

	ApplyTransform(objectToMove, posParameter) {
		if (posParameter.refObject) {
			objectToMove.position.x = posParameter.refObject.position.x;
			objectToMove.position.y = posParameter.refObject.position.y;
			objectToMove.position.z = posParameter.refObject.position.z;

			objectToMove.rotation.x = posParameter.refObject.rotation.x;
			objectToMove.rotation.y = posParameter.refObject.rotation.y;
			objectToMove.rotation.z = posParameter.refObject.rotation.z;
		}
		else {
			if (posParameter.posX) 
				objectToMove.position.x = posParameter.posX;
			if (posParameter.posY)
				objectToMove.position.y = posParameter.posY;
			if (posParameter.posZ)
				objectToMove.position.z = posParameter.posZ;

			if (posParameter.rotX)
				objectToMove.rotation.x = posParameter.rotX;
			if (posParameter.rotY)
				objectToMove.rotation.y = posParameter.rotY;
			if (posParameter.rotZ)
				objectToMove.rotation.z = posParameter.rotZ;

			if (posParameter.transX)
				objectToMove.translateX(posParameter.transX);
			if (posParameter.transY)
				objectToMove.translateY(posParameter.transY);
			if (posParameter.transZ)
				objectToMove.translateZ(posParameter.transZ);
		}

		if (posParameter.functionToAdd) {
			posParameter.functionToAdd();
		}
	}

	CloneElement(elementToClone, parent, posParameter, forceAdd) {
		var nextObject = elementToClone.clone();
		if (elementToClone.simsData) {
			nextObject.simsData = structuredClone(elementToClone.simsData);
		}
		parent.add(nextObject);
		nextObject.rotation.set(0, 0, 0);
		nextObject.parent = parent;
		this.ApplyTransform(nextObject, posParameter);

		if (forceAdd) {
			nextObject.visible = true;
		}
		return nextObject;
	}

	GenerateClasse(parent, posParameter, visibility, simsData, forceAdd) {
		var table = parent.getObjectByName("Classe");
		if (table) {
			var newPos = {posX: 0.3, posZ: -0.3, rotY: 0};
			this.AddElement("bibliotheque/Chaise_Bleue", table, newPos);
			var newPos = {posX: -0.3, posZ: -0.3, rotY: 0};
			this.AddElement("bibliotheque/Chaise_Bleue", table, newPos);

			if (forceAdd) {
				this.ApplyTransform(table, posParameter)
			}
			else if (posParameter.functionToAdd) {
				posParameter.functionToAdd();
			}
			
		}
		else {
			var newClasse = new THREE.Object3D();
			newClasse.name = "Classe";
			var functionToSend = function(e){
				this.GenerateClasse(parent, posParameter, visibility , simsData, forceAdd);
			}.bind(this);
			
			var newPos;
			newPos = {functionToAdd: functionToSend};

			parent.add(newClasse);
			newClasse.simsData = simsData;

			this.AddElement("bibliotheque/Table_Reunion", newClasse, newPos);
		}
	}

	GenerateRonde(parent, posParameter, visibility, simsData, forceAdd) {
		var table = parent.getObjectByName("Ronde");
		if (table) {
			if (table.children.length == 1) {
				var functionToSend = function(e){
					this.GenerateRonde(parent, posParameter, visibility, simsData, forceAdd);
				}.bind(this);

				var newPos = {functionToAdd: functionToSend};
				this.AddElement("bibliotheque/Chaise_Bleue", table, newPos);
			}
			else if (table.children.length == 2) {
				var nextObject;
				var refChaise;
				for (var i = 0; i < table.children.length; i++) {
					if (table.children[i].name == "Chaise_Bleue") {
						refChaise = table.children[i];
						break;
					}
				}

				var posToApply;
				for (let i = 0; i < 10; i++) {
				    const angle = (i / 10) * Math.PI * 2; // Angle équidistant en radians

				    posToApply = {posX: 1 * Math.cos(angle), posZ: 1 * Math.sin(angle)}

				    if (i == 0) {
						this.ApplyTransform(refChaise, posToApply)
				    }
				    else {
						this.CloneElement(refChaise, table, posToApply);
				    }
				}

				if (forceAdd) {
					this.ModifyTable(table);
					this.ApplyTransform(table, posParameter)
				}
				else if (posParameter.functionToAdd) {
					posParameter.functionToAdd();
				}

			}
		}
		else {
			var newRonde = new THREE.Object3D();
			newRonde.name = "Ronde";
			var functionToSend = function(e){
				this.GenerateRonde(parent, posParameter, visibility, simsData, forceAdd);
			}.bind(this);

			var newPos;
			newPos = {functionToAdd: functionToSend};

			parent.add(newRonde);
			newRonde.simsData = simsData;

			this.AddElement("bibliotheque/Table_Ronde", newRonde, newPos);
		}
		
	}

	GeneratePole(parent, posParameter, visibility, simsData, forceAdd) {
		var pole = parent.getObjectByName("Pole");
		if (pole) {
			if (forceAdd && pole.children.length > 2) {
				this.CloneElement(pole, parent, posParameter, forceAdd);
			}
			else {
				if (pole.children.length == 1) {
					var functionToSend = function(e){
						this.GeneratePole(parent, posParameter, visibility, simsData, forceAdd);
					}.bind(this);
					var newPos = {posX: 0.35, posZ: -0.35, rotY: 0, functionToAdd: functionToSend};
					this.AddElement("bibliotheque/Chaise_Bleue", pole, newPos);
				}
				else if (pole.children.length == 2) {
					var nextObject;
					var refTable;
					var refChaise;
					for (var i = 0; i < pole.children.length; i++) {
						if (pole.children[i].name == "Table_Reunion") {
							refTable = pole.children[i];
						}
						else if (pole.children[i].name == "Chaise_Bleue") {
							refChaise = pole.children[i];
						}
					}

					this.CloneElement(refTable, pole, {posX: 0, posZ: 0.7});

					this.CloneElement(refChaise, pole, {posX: -0.35, posZ: -0.35, rotY: 0});
					this.CloneElement(refChaise, pole, {posX: 0.35, posZ: 1, rotY: Math.PI});
					this.CloneElement(refChaise, pole, {posX: -0.35, posZ: 1, rotY: Math.PI});
					this.CloneElement(refChaise, pole, {posX: -0.7, posZ: 0.01, rotY: Math.PI / 2});
					this.CloneElement(refChaise, pole, {posX: -0.7, posZ: 0.7, rotY: Math.PI / 2});
					this.CloneElement(refChaise, pole, {posX: 0.7, posZ: 0.01, rotY: -Math.PI / 2});
					this.CloneElement(refChaise, pole, {posX: 0.7, posZ: 0.7, rotY: -Math.PI / 2});

					if (forceAdd) {
						this.ApplyTransform(pole, posParameter)
					}
					else if (posParameter.functionToAdd) {
						posParameter.functionToAdd();
					}
				}
			}
		}
		else {
			var newPole = new THREE.Object3D();
			newPole.name = "Pole";
			var functionToSend = function(e){
				this.GeneratePole(parent, posParameter, visibility, simsData, forceAdd);
			}.bind(this);

			newPos = {functionToAdd: functionToSend};

			parent.add(newPole);
			newPole.simsData = simsData;

			this.AddElement("bibliotheque/Table_Reunion", newPole, newPos);
		}
	}

	ModifyTable(table) {
		var posToApply;
		var nbChaise = 0;

		for (var i = 0; i < table.children.length; i++) {
			if (table.children[i].name == "Chaise_Bleue") {
				if (nbChaise < 8) {
					const angle = (nbChaise / 8) * Math.PI * 2;
				    posToApply = {posX: 1 * Math.cos(angle), posZ: 1 * Math.sin(angle)}
			    	posToApply.rotY = Math.atan2(-posToApply.posX, -posToApply.posZ);

					this.ApplyTransform(table.children[i], posToApply)
					table.children[i].visible = true;
				}
				else {
					table.children[i].visible = false;
				}
				nbChaise ++;
			}
		}
	}
}